export default __webpack_public_path__ + "static/media/FoodWeb_08.cec579b8.png";